import SelfInitComponent from "General/global-js/SelfInitComponent";
import { Accordion } from "./accordion.js";
import "./accordion.scss";

class AccordionComponent extends SelfInitComponent {
  constructor(selector) {

    super(selector);
  }
  init() {
    Accordion.init();
  }
}
new AccordionComponent(".accordion__module");

